import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import QuestionSetForm from '../../../components/forms/QuestionSetForm';
import { QuestionSetClient, QuestionSetDTO, QuestionSetItemClient, QuestionSetItemDTO } from '../../../services/apiClient';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from '../../../services/axiosInstance';

const QuestionSetCreate: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const apiClient = new QuestionSetClient(API_BASE_URL, axiosInstance);
  const itemClient = new QuestionSetItemClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Question Sets', href: '/admin/questionsets' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: QuestionSetDTO, items: QuestionSetItemDTO[], itemsToDelete: string[]) => {
      setIsSubmitting(true);
      try {
        const response = await apiClient.createQuestionSet(data);
    
        if (response && response.success && response.data?.id) {
          const questionSetId = response.data.id;
    
          // Prepare all API calls (create or update)
          const itemRequests = items.map((item) => {
            const payload = { ...item, questionSetId };
    
            if (!item.id || item.id.trim() === '') {
              return itemClient.createQuestionSetItem(payload);
            } else {
              return itemClient.updateQuestionSetItem(item.id, payload);
            }
          });
    
          // Execute all requests
          await Promise.all(itemRequests);

          // Process any deletes
          if (itemsToDelete.length > 0) {
            await Promise.all(
              itemsToDelete.map((id) => itemClient.deleteQuestionSetItem(id))
            );
          }
        }
    
        navigate('/admin/questionsets');
      } catch (error) {
        console.error('Error updating QuestionSet:', error);
      } finally {
        setIsSubmitting(false);
      }
    };

  return (
    <AdminLayout
      title="Create Question Sets"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      <Card>
        <QuestionSetForm
          initialValues={{} as QuestionSetDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/questionsets')}
        />
      </Card>
    </AdminLayout>
  );
};

export default QuestionSetCreate;
